import React from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import BannerGlobal from '../../Components/Banner/BannerGlobal'
import ProjectDetailsComponent from '../../Components/ProjectComponent/ProjectDetailsComponent'
import ContactComponent from '../../Components/ContactComponent/ContactComponent'
import useDocumentTitle from '../../PageTitle'

const WorkDetails = () => {
  useDocumentTitle("Roofing | Work Details")
  return (
    <div>
        <Header/>
        <BannerGlobal/>
        <ProjectDetailsComponent/>
        <ContactComponent/>
        <Footer/>
    </div>
  )
}

export default WorkDetails